export const authStorage = {
  setAuth(data) {
    localStorage.setItem('is_logged_in', 'true');
    localStorage.setItem('token', data.token);
    localStorage.setItem(
      'mzad_user_info',
      JSON.stringify({
        ...data.user,
        token: data.token,
      })
    );
  },

  clearAuth() {
    localStorage.clear();
  },

  getToken() {
    return localStorage.getItem('token');
  },

  isLoggedIn() {
    return localStorage.getItem('is_logged_in') === 'true';
  },
};
